import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import TripView from "./components/TripView";

export const TripRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route path="/">
        <Route path=":tripNumber/edit" element={<TripView />} />
        <Route path=":tripNumber/*" element={<TripView />} />
      </Route>
    </Routes>
  );
};
